jQuery(document).ready(function() {
   /* global variables */
   var curPage                  = 1;
   var pageSize                 = 24;
   var graphqlAPIURL            = "https://whitelabel.buildzone.net/live/graphql/";
   var stoneListingAPIName      = 'meleeDiamondData';
   var stoneAddToCartAPIName    = 'meleeDiamondAddToCart';
   var queryParams              = new URLSearchParams(window.location.search);
   var stoneTypeSlug            = jQuery('.tps-melee-stone-type-slug').val();
   var curCurrencyCode          = jQuery('.tps-melee-stone-current-currency-code').val();
   var curCurrencySymbol        = jQuery('.tps-melee-stone-current-currency-symbol').val();
   var defaultSortByVal         = jQuery('.tps-melee-stone-default-sort-by-val').val();
   var defaultSortDirVal        = jQuery('.tps-melee-stone-default-sort-dir-val').val();
   var placeholderImgURL        = jQuery('.tps-melee-stone-placeholder-img-url').val();
   var displayQtyBoxPopup       = jQuery('.tps-melee-stone-display-qty-selector-box').val();
   var displayCountry           = jQuery('.tps-melee-stone-display-country').val();
   var filterSessionStorageKey  = `tps-melee-stone-filters-${stoneTypeSlug}`;
   var sortSessionStorageKey    = `tps-melee-stone-sort-options-${stoneTypeSlug}`;
   var preselectedProductSkus   = queryParams.get('product_skus') != null ? queryParams.get('product_skus') : '';   
   var curMeleeStoneInfoJSON    = {};
   var requestXHR               = '';
   var selectedProductSKUList   = [];   
   
   /* global functions */
   appendAppliedFiltersInURL();
   activateAppliedFiltersInHTML();
   displayAppliedFiltersBreadcrumb();
   activateAppliedSortConfigInHTML();
   fetchMeleeStones();

   /* global events */
   jQuery(document).on({
    click : function(e) {
        var filterOptions = [];
        var filterOption  = jQuery(this);        
        var filterDiv     = filterOption.parents('.tps-melee-stone-filter-content-row');
        var filterType    = filterDiv.data('filter-type');
        var filterLabel   = filterDiv.find('.tps-filter-label').text();
        filterOptions     = getSelectedChkFilterOptions(filterDiv);                
        updateFilterURLQueryParams(filterType, filterOptions);
        updateFilterSessionStorageParams(filterType, filterOptions);      
        updateAppliedFiltersHTML(filterType, filterLabel, filterOptions, 'checkbox-filter');
        resetPageToFirstPage();
        emptyMeleeStonesResultDiv();
        fetchMeleeStones();   
    },
   }, '.tps-filter-option-chk');

   jQuery(document).on({
    keydown : function(e) {        
        if (e.which == 13) {
            var inputField = jQuery(this);
            handleRangeFilterInpBoxOperation(inputField, 'min-value');       
        }
    },
    blur : function(e) {
        var inputField = jQuery(this);
        handleRangeFilterInpBoxOperation(inputField, 'min-value');
    },
   }, '.tps-melee-stone-min-inp-field');

   jQuery(document).on({
    keydown : function(e) {        
        if (e.which == 13) {
            var inputField = jQuery(this);
            handleRangeFilterInpBoxOperation(inputField, 'max-value');
        }
    },
    blur : function(e) {
        var inputField = jQuery(this);
        handleRangeFilterInpBoxOperation(inputField, 'max-value');
    },
   }, '.tps-melee-stone-max-inp-field');

   jQuery(document).on({
    click : function(e) {
        curPage ++;
        fetchMeleeStones();
    },
   }, '.tps-melee-stone-load-more-btn');

   jQuery(document).on({
    click : function(e) {
        jQuery("html, body").animate({ scrollTop: 0 }, "slow");
    }
   }, '.tps-melee-stone-go-top-link');

   jQuery(document).on({
    click : function(e) {
        jQuery('.tps-melee-stone-reset-filter-options-div').show();
    },
   }, '.tps-melee-stone-reset-filter-title');

   jQuery(document).on({
    click : function(e) {
        jQuery('.tps-melee-stone-reset-filter-options-div').show();
    },
   }, '.tps-melee-stone-reset-filter-title');

   jQuery(document).on({
    click : function(e) {
        jQuery('.tps-melee-stone-reset-filter-options-div').hide();
    },
   }, '.tps-melee-stone-reset-filter-no-btn');

   jQuery(document).on({
    click : function(e) {
        jQuery('.tps-melee-stone-reset-filter-options-div').hide();
        resetMeleeStoneFilters();
    },
   }, '.tps-melee-stone-reset-filter-yes-btn, .tps-melee-stone-reset-filter-btn, .tps-melee-stone-applied-filter-reset-btn');

   jQuery(document).on({
    click : function(e) {
        var curTarget = jQuery(e.target);
        if (curTarget.parents('.tps-melee-stone-reset-filter-div').length < 1) {
            jQuery('.tps-melee-stone-reset-filter-options-div').hide();
        }
    },
   });

   jQuery(document).on({
    click : function(e) {
        var curOption                   = jQuery(this);
        var appliedFilterCardOptionDiv  = curOption.parents('.tps-melee-stone-applied-filter-card-option');
        var filterType                  = appliedFilterCardOptionDiv.data('filter-type');        
        var currentFilterDiv            = jQuery(`.tps-melee-stone-filter-content-row.tps-${filterType}`);
        if (currentFilterDiv.hasClass('tps-checkbox-filter')) {
            var selectedFilterOption    = appliedFilterCardOptionDiv.data('filter-option');
            currentFilterDiv.find(`.tps-filter-option-chk[value="${selectedFilterOption}"]`).trigger('click');
        } else if(currentFilterDiv.hasClass('tps-range-filter')) {
            var defaultMinVal = currentFilterDiv.find('.tps-melee-stone-min-default-val').val();
            var defaultMaxVal = currentFilterDiv.find('.tps-melee-stone-max-default-val').val();
            currentFilterDiv.find('.tps-melee-stone-min-inp-field').val(defaultMinVal);
            currentFilterDiv.find('.tps-melee-stone-max-inp-field').val(defaultMaxVal);
            currentFilterDiv.find('.tps-melee-stone-min-inp-field').trigger(
                jQuery.Event('keydown', { key: 'Enter', keyCode: 13, which: 13 })
            );
        } 
    },
   }, '.tps-melee-stone-applied-filter-card-option-remove');

   jQuery(document).on({
    click : function(e) {
        var activeSortOptionSpanEle = jQuery(this);
        if (activeSortOptionSpanEle.hasClass('tps-arrow-down')) {
            activeSortOptionSpanEle.removeClass('tps-arrow-down').addClass('tps-arrow-up');
        } else {
            activeSortOptionSpanEle.removeClass('tps-arrow-up').addClass('tps-arrow-down');
        }
        activeSortOptionSpanEle.next('.tps-melee-stone-sort-option-list').slideToggle(600);
    }
   }, '.tps-melee-stone-sort-option-active');

   jQuery(document).on({
    click : function(e) {
        var curSortOption    = jQuery(this);
        var sortByValue      = curSortOption.data('sort-by');
        var sortDirValue     = curSortOption.data('sort-dir');
        var sortOptionLabel  = curSortOption.text().trim();
        jQuery('.tps-melee-stone-sort-option-active').trigger('click');
        markSortOptionAsActive(curSortOption);        
        setMeleeStoneSortOptions(sortByValue, sortDirValue);
        resetPageToFirstPage();
        emptyMeleeStonesResultDiv();
        fetchMeleeStones();
    },
   }, '.tps-melee-stone-sort-option-li');

   jQuery(document).on({
    click : function(e) {
        var curTarget = jQuery(e.target);
        if (curTarget.parents('.tps-melee-stone-sort-option-content').length < 1) {
            jQuery('.tps-melee-stone-sort-option-active').removeClass('tps-arrow-up').addClass('tps-arrow-down');
            jQuery('.tps-melee-stone-sort-option-list').slideUp(600);
        }
    }
   });

   jQuery(document).on({
    click : function(e) {
        var meleeStoneCard      = jQuery(this).parents('.tps-melee-stone-info-card');
        var stoneTitle          = meleeStoneCard.find('.tps-melee-stone-title').text();        
        var stoneImgURL         = meleeStoneCard.find('.tps-melee-stone-main-img').attr('src');                
        curMeleeStoneInfoJSON   = JSON.parse(meleeStoneCard.find('.tps-melee-stone-info-json').val());        
        var stoneInfoJSON       = {
            'stone_title'       : stoneTitle,            
            'stone_img_url'     : stoneImgURL,
            'stone_country'     : curMeleeStoneInfoJSON['location'],
        };
        updateStoneQtySelectorBoxContentAndOpenIt(stoneInfoJSON);        
    },
   }, '.tps-melee-stone-select-qty');

   jQuery(document).on({
    click : function(e) {
        var qtySelectorBox = jQuery('.tps-melee-stone-qty-selector-box-container');                        
        resetMeleeStoneQtySelectorBoxParameters(qtySelectorBox);
        qtySelectorBox.removeClass('tps-activate-qty-selector');
    }
   }, '.tps-melee-stone-qty-selector-box-btn.tps-cancel, .tps-melee-stone-qty-selector-box-close');

   jQuery(document).on({
    click : function(e) {
        var curBtnEle = jQuery(this);        
        if (displayQtyBoxPopup == 'no') {
            curMeleeStoneInfoJSON   = JSON.parse(curBtnEle.parents('.tps-melee-stone-info-card').find('.tps-melee-stone-info-json').val());
        }
        var formDiv = curBtnEle.parents('.tps-melee-stone-qty-selector-box-content-wrapper');
        curBtnEle.siblings('.tps-melee-stone-qty-selector-box-btn').removeClass('active');
        curBtnEle.addClass('active');
        formDiv.find('.tps-melee-stone-qty-selector-box-form.tps-form-by-pieces').hide();
        formDiv.find('.tps-melee-stone-qty-selector-box-form.tps-form-by-carat').show();
        calculateNumberOfStonePieces(formDiv.find('.tps-melee-stone-qty-selector-box-form.tps-form-by-carat').find('.tps-melee-stone-qty-selector-box-inp-field'), formDiv);
    },
   }, '.tps-melee-stone-qty-selector-box-btn.tps-select-by-carat');

   jQuery(document).on({
    click : function(e) {
        var curBtnEle = jQuery(this);        
        if (displayQtyBoxPopup == 'no') {
            curMeleeStoneInfoJSON   = JSON.parse(curBtnEle.parents('.tps-melee-stone-info-card').find('.tps-melee-stone-info-json').val());
        }
        var formDiv = curBtnEle.parents('.tps-melee-stone-qty-selector-box-content-wrapper');
        curBtnEle.siblings('.tps-melee-stone-qty-selector-box-btn').removeClass('active');
        curBtnEle.addClass('active');
        formDiv.find('.tps-melee-stone-qty-selector-box-form.tps-form-by-carat').hide();
        formDiv.find('.tps-melee-stone-qty-selector-box-form.tps-form-by-pieces').show();
        calculateTotalStoneCaratWeight(formDiv.find('.tps-melee-stone-qty-selector-box-form.tps-form-by-pieces').find('.tps-melee-stone-qty-selector-box-inp-field'), formDiv);
    },
   }, '.tps-melee-stone-qty-selector-box-btn.tps-select-by-pieces');

   jQuery(document).on({
    keyup : function(e) {
        var inputFieldEle = jQuery(this); 
        if (displayQtyBoxPopup == 'no') {
            curMeleeStoneInfoJSON   = JSON.parse(inputFieldEle.parents('.tps-melee-stone-info-card').find('.tps-melee-stone-info-json').val());
        }
        var formDiv = inputFieldEle.parents('.tps-melee-stone-qty-selector-box-content-wrapper');       
        calculateNumberOfStonePieces(inputFieldEle, formDiv);
    },
   }, '.tps-melee-stone-qty-selector-box-form.tps-form-by-carat .tps-melee-stone-qty-selector-box-inp-field');

   jQuery(document).on({
    keyup : function(e) {
        var inputFieldEle = jQuery(this);
        if (displayQtyBoxPopup == 'no') {
            curMeleeStoneInfoJSON   = JSON.parse(inputFieldEle.parents('.tps-melee-stone-info-card').find('.tps-melee-stone-info-json').val());
        }
        var formDiv = inputFieldEle.parents('.tps-melee-stone-qty-selector-box-content-wrapper');
        calculateTotalStoneCaratWeight(inputFieldEle, formDiv);
    },
   }, '.tps-melee-stone-qty-selector-box-form.tps-form-by-pieces .tps-melee-stone-qty-selector-box-inp-field');

   jQuery(document).on({
    click : function(e) {
        var btnEle = jQuery(this);
        if (displayQtyBoxPopup == 'no') {
            curMeleeStoneInfoJSON = JSON.parse(btnEle.parents('.tps-melee-stone-info-card').find('.tps-melee-stone-info-json').val());
        }
        var formDiv = btnEle.parents('.tps-melee-stone-qty-selector-box-content-wrapper');
        var graphqlQuery    = getMeleeStoneAddToCartGraphqlRequest(formDiv);  
        jQuery.ajax({
            url : graphqlAPIURL,
            method: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data : JSON.stringify({ query : `query{${graphqlQuery}}`}),
            beforeSend : function() {                
                btnEle.addClass('tps-loading');
            },
            success : function(response) {                                       
                var graphqlResponse = response['data'][stoneAddToCartAPIName];
                if (graphqlResponse['code'] != '200') {
                    jQuery('.tps-melee-stone-qty-selector-box-error-note').text(graphqlResponse['message']);
                    return;
                }
                addMeleeStoneIntoShopifyCart(formDiv, btnEle, graphqlResponse['productId'], graphqlResponse['variantId']);
            }
        });
    },
   }, '.tps-melee-stone-qty-selector-box-btn.tps-add-to-cart');

   jQuery(document).on({
    click : function(e) {
        var curTarget = jQuery(e.target);
        if (!curTarget.hasClass('tps-melee-stone-select-qty') && curTarget.parents('.tps-melee-stone-qty-selector-box-content-wrapper').length < 1) {
            var qtySelectorBox = jQuery('.tps-melee-stone-qty-selector-box-container');            
            resetMeleeStoneQtySelectorBoxParameters(qtySelectorBox);
            qtySelectorBox.removeClass('tps-activate-qty-selector');
        }
    }
   });

   jQuery(document).on({
    click : function(e) {
        var filterDiv = jQuery('.tps-melee-stone-main-top-content-wrapper');        
        filterDiv.addClass('tps-open-filter-panel');
    },
   }, '.tps-melee-stone-listing-mobile-open-filter');

   jQuery(document).on({
    click : function(e) {
        var filterDiv = jQuery('.tps-melee-stone-main-top-content-wrapper');        
        filterDiv.removeClass('tps-open-filter-panel');
    },
   }, '.tps-melee-stone-listing-mobile-close-filter');

   jQuery(document).on({
    click : function(e) {
        var curTarget = jQuery(e.target);
        var filterDiv = jQuery('.tps-melee-stone-main-top-content-wrapper');        
        if (!curTarget.hasClass('tps-melee-stone-listing-mobile-open-filter') && curTarget.parents('.tps-melee-stone-main-top-content').length < 1) {
            filterDiv.removeClass('tps-open-filter-panel');
        }
    },
   });

   jQuery(document).on({
    click : function(e) {
        var filterDiv = jQuery('.tps-melee-stone-main-top-content-wrapper');        
        filterDiv.removeClass('tps-open-filter-panel');
        fetchMeleeStones();
    },
   }, '.tps-melee-stone-listing-mobile-view-result');

   jQuery(document).on({
    click : function(e) {
        var curTab = jQuery(this);
        location.href= curTab.data('page-url');
    }
   }, '.tps-melee-stone-listing-type-tab');

    var lastScrollTop    = 0;
    var scrollDir        = 'down';    
    var listingTopHeader = jQuery('.tps-melee-stone-listing-header-content');
    var listingLabelSpan = jQuery('.tps-melee-stone-listing-h1-title');
    var listingLabelSpanTop = listingLabelSpan.offset().top;
   jQuery(window).scroll(function(e) {
    var headerDiv       = jQuery('.spaced-header').length > 0 ? jQuery('.spaced-header') : jQuery('header');
    var mobileFilterBtn = jQuery('.tps-melee-stone-listing-mobile-open-filter');
    var scrollTop       = jQuery(window).scrollTop();
    if (scrollTop > lastScrollTop) {
        scrollDir = 'down';
    } else {
        scrollDir = 'up';
    }
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

    if (scrollTop > 100) {
        mobileFilterBtn.addClass('tps-sticky');
    } else {
        mobileFilterBtn.removeClass('tps-sticky');
    } 

    /* add sticky class to top counter bar */
    if (scrollTop >= listingLabelSpanTop) {        
        listingTopHeader.addClass('tps-sticky');
        listingTopHeader.css('top', headerDiv.hasClass('shopify-section-header-sticky') ? jQuery('.header-bottom').height() - 5  : '0px');         
    } else {
        listingTopHeader.removeClass('tps-sticky');
    }
   });

   jQuery(document).on({
    click : function(e) {              
        var curChkEle       = jQuery(this);
        var infoCard        = curChkEle.parents('.tps-melee-stone-info-card');
        var curStoneInfoJSON= JSON.parse(infoCard.find('.tps-melee-stone-info-json').val());
        if (curChkEle.is(':checked')) {
            selectedProductSKUList.push(curStoneInfoJSON);
        } else {
            selectedProductSKUList = selectedProductSKUList.filter(function(curInfoJSON) {
                return curInfoJSON['productSku'] != curStoneInfoJSON['productSku'];
            });
        }
        if (selectedProductSKUList.length > 0) {
            jQuery('.tps-melee-stone-listing-header-content').addClass('tps-whatsapp-share-active');
            jQuery('.tps-whats-app-share-div').show();
            jQuery('.tps-whats-app-selected-item-count').text(`(${selectedProductSKUList.length})`);    
        } else {
            jQuery('.tps-melee-stone-listing-header-content').removeClass('tps-whatsapp-share-active');
            jQuery('.tps-whats-app-share-div').hide();
        }
    }
   }, '.tps-melee-stone-whats-app-shareable-chk');

   jQuery(document).on({
    click : function(e) {
        var btnEle          = jQuery(this);        
        var productSKUs     = [];
        var msgContent = "Selected Melee Stone Packages\n";
        var stoneIndex = 1;
        for(var stoneInfoJSON of selectedProductSKUList) {
            productSKUs.push(stoneInfoJSON['productSku']);
            msgContent += getMsgContentOfCurStone(stoneIndex, stoneInfoJSON);
            stoneIndex ++;
        }
        msgContent += `\nPlease review the consolidated list of the selected melee packages below:\n`;
        msgContent += getWhatsAppShareURL(productSKUs);
        var whatsappURL = `https://api.whatsapp.com/send?text=${encodeURIComponent(msgContent)}`;
        window.open(whatsappURL, '_blank');
    },
   }, '.tps-whats-app-share-btn');

   /* useful functions */

   /* get whats app share URL */
   function getWhatsAppShareURL(productSKUs = []) {
    var currentURLPath = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
    var newUrl 		   = `${currentURLPath}?product_skus=${productSKUs.join(',')}`;
    return newUrl;
   }

   /* get current stone message content for current stone */
   function getMsgContentOfCurStone(stoneIndex, stoneInfoJSON) {
    var stoneTypeTitle = getStoneTypeTitle();
    var stoneTitle     = getMeleeStoneTitle(stoneInfoJSON);
    var stoneSKU       = stoneInfoJSON['productSku'];
    var stoneColor     = stoneInfoJSON['fancyColor'] != '' ? stoneInfoJSON['fancyColor'] : stoneInfoJSON['color'];
    var stoneClarity   = stoneInfoJSON['clarity'];
    var stoneCut       = stoneInfoJSON['cut'];
    var stoneShape     = stoneInfoJSON['shape'];    
    var priceToShow    = `${curCurrencySymbol}${stoneInfoJSON['pricePerCarat']}/ct`;
    var meleeStoneLabel= `${stoneTypeTitle} ${stoneShape} Melee`;
    var stoneWeightText= `${stoneInfoJSON['avgCaratPerStone']} ct per stone`;
    var msgContent = `
        ${meleeStoneLabel}
        Parcel ${stoneIndex} : ${stoneTitle}
        SKU   : ${stoneSKU}
        Color : ${stoneColor}
        Clarity : ${stoneClarity}
        Cut   : ${stoneCut}
        Price : ${priceToShow}
        Avg weight: ${stoneWeightText}
    `;
    return msgContent;
   }

   /* reset qty selector box parameters on close of qty selector box */
   function resetMeleeStoneQtySelectorBoxParameters(qtySelectorBox) {
    qtySelectorBox.find('.tps-melee-stone-qty-selector-box-form.tps-form-by-carat').find('.tps-melee-stone-qty-selector-box-inp-field').val('');
    qtySelectorBox.find('.tps-melee-stone-qty-selector-box-form.tps-form-by-pieces').find('.tps-melee-stone-qty-selector-box-inp-field').val(1);
    qtySelectorBox.find('.tps-melee-stone-qty-selector-box-total-final-price').text(`${curCurrencySymbol}0.00`);
   }

   /* add melee stone product into shopify cart */
   function addMeleeStoneIntoShopifyCart(formDiv, btnEle, productId, variantId) {
    var activeField     = formDiv.find('.tps-melee-stone-qty-selector-box-btn.tps-select-by-pieces').hasClass('active') ? 'by-pieces' : 'by-carat';     
    var fieldValue      = formDiv.find(`.tps-melee-stone-qty-selector-box-form.tps-form-${activeField}`).find('.tps-melee-stone-qty-selector-box-inp-field').val();
    var activeFieldLabel= activeField == 'by-pieces' ? 'Pieces' : 'Carat(ct.)';
     jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            id: variantId,
            quantity: 1,
            properties:{
                'Selected By'    : activeFieldLabel,
                'Selected Value' : fieldValue,
            },
        },
        dataType: 'json',
        success: function (response) {            
            window.location.href = '/cart';
        },
        complete : function() {
            btnEle.removeClass('tps-loading');
        },
        error: function (xhr) {
            formDiv.find('.tps-melee-stone-qty-selector-box-error-note').text(xhr.responseJSON.description);
        }
    }); 
   }

   /* get melee stone add to cart graphql request */
   function getMeleeStoneAddToCartGraphqlRequest(formDiv) {
    var activeField     = formDiv.find('.tps-melee-stone-qty-selector-box-btn.tps-select-by-pieces').hasClass('active') ? 'by-pieces' : 'by-carat'; 
    var fieldValue      = formDiv.find(`.tps-melee-stone-qty-selector-box-form.tps-form-${activeField}`).find('.tps-melee-stone-qty-selector-box-inp-field').val();   
    var stoneId         = curMeleeStoneInfoJSON['productSku'];
    var stoneType       = curMeleeStoneInfoJSON['diamondType'];
    var stoneImageURL   = curMeleeStoneInfoJSON['image'];
    var query           = `
        ${stoneAddToCartAPIName}(meleeId: "${stoneId}", meleeType: "${stoneType}", currencyFlag: "${curCurrencyCode}", diamondImage: "${stoneImageURL}", ${activeField == 'by-pieces' ? 'quantityPieces:"'+fieldValue+'"' : 'quantityCarat:"'+fieldValue+'"'}) {
            status
            code
            message
            productId
            variantId
            alreadyExists
            addedCarat
            addedPieces
            uuid
        }
    `; 
    return query;
   }
   
   /* calculate total stone carat weight */
   function calculateTotalStoneCaratWeight(inputFieldEle, formDiv) {
    var suggestionBox = inputFieldEle.parents('.tps-melee-stone-qty-selector-box-form').find('.tps-melee-stone-qty-selector-box-form-suggestion');
    var enteredStonePieces = parseFloat(inputFieldEle.val() == '' ? '0' : inputFieldEle.val());
    var minPieces     = parseFloat(inputFieldEle.attr('min'));
    var maxPieces     = parseFloat(inputFieldEle.attr('max'));
    inputFieldEle.removeClass('tps-highlight');
    if (enteredStonePieces < minPieces) {
        inputFieldEle.addClass('tps-highlight');
        suggestionBox.text(`Add at least ${minPieces} piece`);
        formDiv.find('.tps-melee-stone-qty-selector-box-btn.tps-add-to-cart').addClass('tps-disabled');
        formDiv.find('.tps-melee-stone-qty-selector-box-total-final-price').text(`${curCurrencySymbol}0.00`);
        return;
    } else if(enteredStonePieces > maxPieces) {
        inputFieldEle.addClass('tps-highlight');
        suggestionBox.text(`You can add upto ${maxPieces} pieces`);
        formDiv.find('.tps-melee-stone-qty-selector-box-btn.tps-add-to-cart').addClass('tps-disabled');
        formDiv.find('.tps-melee-stone-qty-selector-box-total-final-price').text(`${curCurrencySymbol}0.00`);
        return;
    }            
    formDiv.find('.tps-melee-stone-qty-selector-box-btn.tps-add-to-cart').removeClass('tps-disabled');
    var avgCaratPerStone = parseFloat(curMeleeStoneInfoJSON['avgCaratPerStone']);    
    var pricePerCarat    = parseFloat(curMeleeStoneInfoJSON['pricePerCarat']);
    var totalCaratWeight = avgCaratPerStone * enteredStonePieces;    
    var totalPriceToShow = `${curCurrencySymbol}${getFormatedPrice((pricePerCarat * totalCaratWeight).toFixed(2))}`;
    suggestionBox.text(`Approx. ${totalCaratWeight.toFixed(4)} carats`);
    formDiv.find('.tps-melee-stone-qty-selector-box-form.tps-form-by-carat').find('.tps-melee-stone-qty-selector-box-inp-field').val(totalCaratWeight.toFixed(4));
    formDiv.find('.tps-melee-stone-qty-selector-box-total-final-price').text(totalPriceToShow);
   }

   /* get total price of melee stones */
   function getTotalPriceOfSelectedStonePieces(numberOfStones, avgCaratPerStone, pricePerCarat) {
    var totalCaratWeight = avgCaratPerStone * numberOfStones;
    var totalPriceToShow = `${curCurrencySymbol}${getFormatedPrice((pricePerCarat * totalCaratWeight).toFixed(2))}`; 
    return totalPriceToShow;
   }

   /* get average total carat weight text for single stone */
   function getTotalCaratWeightForSelectedStone(numberOfStones, avgCaratPerStone, requireText = true) {
    var totalCaratWeight = (avgCaratPerStone * numberOfStones).toFixed(4);    
    return requireText ? `Approx. ${totalCaratWeight} carats` : totalCaratWeight;
   }

   /* calculate number of pieces */
   function calculateNumberOfStonePieces(inputFieldEle, formDiv) {
    var suggestionBox = inputFieldEle.parents('.tps-melee-stone-qty-selector-box-form').find('.tps-melee-stone-qty-selector-box-form-suggestion');
    var enteredCaratValue = parseFloat(inputFieldEle.val() == '' ? '0' : inputFieldEle.val());
    var minCarat      = parseFloat(inputFieldEle.attr('min'));
    var maxCarat      = parseFloat(inputFieldEle.attr('max'));
    inputFieldEle.removeClass('tps-highlight');
    if (enteredCaratValue < minCarat) {
        inputFieldEle.addClass('tps-highlight');
        suggestionBox.text(`Add at least ${minCarat} carats`);
        formDiv.find('.tps-melee-stone-qty-selector-box-btn.tps-add-to-cart').addClass('tps-disabled');
        formDiv.find('.tps-melee-stone-qty-selector-box-total-final-price').text(`${curCurrencySymbol}0.00`);
        return;
    } else if(enteredCaratValue > maxCarat) {
        inputFieldEle.addClass('tps-highlight');
        suggestionBox.text(`You can add upto ${maxCarat} carats`);
        formDiv.find('.tps-melee-stone-qty-selector-box-btn.tps-add-to-cart').addClass('tps-disabled');
        formDiv.find('.tps-melee-stone-qty-selector-box-total-final-price').text(`${curCurrencySymbol}0.00`);
        return;
    }            
    formDiv.find('.tps-melee-stone-qty-selector-box-btn.tps-add-to-cart').removeClass('tps-disabled');
    var avgCaratPerStone = parseFloat(curMeleeStoneInfoJSON['avgCaratPerStone']);    
    var pricePerCarat    = parseFloat(curMeleeStoneInfoJSON['pricePerCarat']);
    var noOfStonePieces  = Math.ceil(enteredCaratValue/avgCaratPerStone);
    var totalPriceToShow = `${curCurrencySymbol}${getFormatedPrice((pricePerCarat * enteredCaratValue).toFixed(2))}`;
    suggestionBox.text(`Approx. ${noOfStonePieces} pieces`);
    formDiv.find('.tps-melee-stone-qty-selector-box-form.tps-form-by-pieces').find('.tps-melee-stone-qty-selector-box-inp-field').val(noOfStonePieces);
    formDiv.find('.tps-melee-stone-qty-selector-box-total-final-price').text(totalPriceToShow);
   }

   /* set information in stone qty selector box */
   function updateStoneQtySelectorBoxContentAndOpenIt(stoneInfoJSON) {
    var qtySelectorBox          = jQuery('.tps-melee-stone-qty-selector-box-container');
    var qtySelectorBoxImgEle    = qtySelectorBox.find('.tps-melee-stone-qty-selector-box-img');
    var defaultCaratRange       = getDefaultMinMaxCaratValues();
    var caratBoxDiv             = qtySelectorBox.find('.tps-melee-stone-qty-selector-box-form.tps-form-by-carat');
    var piecesBoxDiv            = qtySelectorBox.find('.tps-melee-stone-qty-selector-box-form.tps-form-by-pieces');
    var priceToShow             = `${curCurrencySymbol}${getFormatedPrice(curMeleeStoneInfoJSON['pricePerCarat'])}/ct`;
    var titleParams             = getMeleeStoneQtyBoxTitleParams(curMeleeStoneInfoJSON);
    qtySelectorBox.find('.tps-melee-stone-qty-selector-box-info-title').html(titleParams);
    qtySelectorBox.find('.tps-melee-stone-qty-selector-box-info-price').text(priceToShow);
    qtySelectorBox.find('.tps-melee-stone-qty-selector-box-info-country-text').text(stoneInfoJSON['stone_country']);
    qtySelectorBoxImgEle.attr('src', stoneInfoJSON['stone_img_url']).attr('alt', stoneInfoJSON['stone_title']).attr('title', stoneInfoJSON['stone_title']);
    caratBoxDiv.find('.tps-melee-stone-qty-selector-box-inp-field').attr('min', defaultCaratRange['min_carat']).attr('max', curMeleeStoneInfoJSON['caratsAvailable']).removeClass('tps-highlight');
    piecesBoxDiv.find('.tps-melee-stone-qty-selector-box-inp-field').attr('min', 1).attr('max', curMeleeStoneInfoJSON['piecesAvailable']).removeClass('tps-highlight');
    qtySelectorBox.addClass('tps-activate-qty-selector');
    jQuery('.tps-melee-stone-qty-selector-box-btn.tps-select-by-pieces').trigger('click');
   }

   /* get qty selector box title params */
   function getMeleeStoneQtyBoxTitleParams(curMeleeStoneInfoJSON) {
    var color = curMeleeStoneInfoJSON['color'] != '' ? curMeleeStoneInfoJSON['color'] : curMeleeStoneInfoJSON['fancyColor'];    
    var titlePartHTML = `
    <div class="tps-title-part-col">
        <span class="tps-title-part-col-val">${color}</span>
        <span class="tps-title-part-col-label">Color</span>
    </div>
    <div class="tps-title-part-col">
        <span class="tps-title-part-col-val">${curMeleeStoneInfoJSON['shape']}</span>
        <span class="tps-title-part-col-label">Shape</span>
    </div>
    <div class="tps-title-part-col">
        <span class="tps-title-part-col-val">${curMeleeStoneInfoJSON['cut']}</span>
        <span class="tps-title-part-col-label">Cut</span>
    </div>
    <div class="tps-title-part-col">
        <span class="tps-title-part-col-val">${curMeleeStoneInfoJSON['sizeMmFrom']}-${curMeleeStoneInfoJSON['sizeMmTo']}</span>
        <span class="tps-title-part-col-label">mm</span>
    </div>    
    `;
    return titlePartHTML;
   }

   /* get default min/max carat range */
   function getDefaultMinMaxCaratValues() {
    var caratFilterDiv = jQuery('.tps-melee-stone-filter-content-row.tps-carat-range');
    return {
        'min_carat' : caratFilterDiv.find('.tps-melee-stone-min-default-val').val(),
        'max_carat' : caratFilterDiv.find('.tps-melee-stone-max-default-val').val(),
    };
   }

   /* reset page to first page */
   function resetPageToFirstPage() {
    curPage = 1;
    preselectedProductSkus = '';
   }

   /* make empty melee stone result grid div */
   function emptyMeleeStonesResultDiv() {
    jQuery('.tps-melee-stone-result-grid').empty();
   }

   /* handle range filter input box values */
   function handleRangeFilterInpBoxOperation(inputField, fieldType) {
    var filterDiv  = inputField.parents('.tps-melee-stone-filter-content-row');
    var filterType = filterDiv.data('filter-type');
    var filterLabel= filterDiv.find('.tps-filter-label').text();
    var enteredVal = inputField.val();
    var { defaultMinVal, defaultMaxVal } = getDefaultMinMaxFilterValues(filterDiv);                        
    if(enteredVal == '') {
        inputField.val(fieldType == 'min-value' ? defaultMinVal : defaultMaxVal);
    } else if(enteredVal < defaultMinVal || enteredVal > defaultMaxVal) {
        inputField.val(fieldType == 'min-value' ? defaultMinVal : defaultMaxVal);
    }
    var enteredFilterMinVal = filterDiv.find('.tps-melee-stone-min-inp-field').val();
    var enteredFilterMaxVal = filterDiv.find('.tps-melee-stone-max-inp-field').val();
    var filterOptions       = [enteredFilterMinVal, enteredFilterMaxVal];
    if ((enteredFilterMinVal == defaultMinVal) && (enteredFilterMaxVal == defaultMaxVal)) filterOptions = [];
    updateFilterURLQueryParams(filterType, filterOptions);
    updateFilterSessionStorageParams(filterType, filterOptions);  
    updateAppliedFiltersHTML(filterType, filterLabel, filterOptions, 'range-filter');
    resetPageToFirstPage();
    emptyMeleeStonesResultDiv();
    fetchMeleeStones();       
   }

   /* reset melee stone sort options */
   function resetMeleeStoneSortOptions() {
    sessionStorage.removeItem(sortSessionStorageKey);    
    var activeSortOption  = jQuery(`.tps-melee-stone-sort-option-li[data-sort-by="${defaultSortByVal}"][data-sort-dir="${defaultSortDirVal}"]`);
    markSortOptionAsActive(activeSortOption);
   }

   /* set applied sort configuration in html */
   function activateAppliedSortConfigInHTML() {
    var sortOptionConfig = getMeleeStoneSortOptions();
    var activeSortOption = jQuery(`.tps-melee-stone-sort-option-li[data-sort-by="${sortOptionConfig['sort_by']}"][data-sort-dir="${sortOptionConfig['sort_dir']}"]`);
    markSortOptionAsActive(activeSortOption);    
   }

   /* mark sort option as active */
   function markSortOptionAsActive(activeSortOption) {
    var activeSortOptionLabel = activeSortOption.text().trim();
    jQuery('.tps-melee-stone-sort-option-active').text(activeSortOptionLabel);
    jQuery('.tps-melee-stone-sort-option-li').removeClass('active');
    activeSortOption.addClass('active');
   }

   /* set sort options to session storage */
   function setMeleeStoneSortOptions(sortByValue, sortDirValue) {
    var sortOptionConfig = {
        'sort_by'   : sortByValue,
        'sort_dir'  : sortDirValue,
    };
    sessionStorage.setItem(sortSessionStorageKey, JSON.stringify(sortOptionConfig));
   }

   /* get selected sort options from session storage */
   function getMeleeStoneSortOptions() {
    var sortOptionConfig        = {
        'sort_by'   : defaultSortByVal,
        'sort_dir'  : defaultSortDirVal,
    };
    var storedSortOptionConfig  = sessionStorage.getItem(sortSessionStorageKey);
    if (storedSortOptionConfig != null && storedSortOptionConfig != '' && storedSortOptionConfig != undefined) {
        sortOptionConfig        = JSON.parse(storedSortOptionConfig);
    }
    return sortOptionConfig;
   }

   /* display applied filters breadcrumbs */
   function displayAppliedFiltersBreadcrumb() {
    appliedFilterList = getAppliedFilterList();
    if (Object.keys(appliedFilterList).length > 0) {
        for (var filterType in appliedFilterList) {
            var filterOptions   = appliedFilterList[filterType].split(',');
            var filterDiv       = jQuery(`.tps-melee-stone-filter-content-row.tps-${filterType}`);
            var filterHTMLType  = filterDiv.hasClass('tps-checkbox-filter') ? 'checkbox-filter' : 'range-filter';            
            var filterLabel     = filterDiv.find('.tps-filter-label').text();
            updateAppliedFiltersHTML(filterType, filterLabel, filterOptions, filterHTMLType);
        }   
    }
   }

   /* activate applied filters in HTML */
   function activateAppliedFiltersInHTML() {
    appliedFilterList = getAppliedFilterList();
    if (Object.keys(appliedFilterList).length > 0) {
        for (var filterType in appliedFilterList) {
            var filterOptions   = appliedFilterList[filterType].split(',');
            var filterDiv       = jQuery(`.tps-melee-stone-filter-content-row.tps-${filterType}`);
            var filterHTMLType  = filterDiv.hasClass('tps-checkbox-filter') ? 'checkbox-filter' : 'range-filter';
            if (filterHTMLType == 'checkbox-filter') {
                activateAppliedCheckboxFiltersInHTML(filterDiv, filterOptions);    
            } else if (filterHTMLType == 'range-filter') {
                activateAppliedRangeFiltersInHTML(filterDiv, filterOptions);
            }
        }
    }
   }

   /* activate checkbox applied filters in HTML */
   function activateAppliedCheckboxFiltersInHTML(filterDiv, filterOptions = []) {
    for (var filterOption of filterOptions) {
        filterDiv.find(`.tps-filter-option-chk[value="${filterOption}"]`).prop('checked', true);
    }
   }

   /* activate range applied filters in HTML */
   function activateAppliedRangeFiltersInHTML(filterDiv, filterOptions = []) {
    filterDiv.find('.tps-melee-stone-min-inp-field').val(filterOptions[0]);
    filterDiv.find('.tps-melee-stone-max-inp-field').val(filterOptions[1]);
   }

   /* append applied filters in URL */
   function appendAppliedFiltersInURL() {
    appliedFilterList = getAppliedFilterList();
    if (Object.keys(appliedFilterList).length > 0) {
        for (var filterType in appliedFilterList) {
            queryParams.set(filterType, appliedFilterList[filterType]);
        }    
        updatePageURL(queryParams);
    }
   }

   /* handle applied filters html */
   function updateAppliedFiltersHTML(filterType, filterLabel, filterOptions, filterHTMLType) {
    var appliedFiltersParentDiv     = jQuery('.tps-melee-stone-listing-applied-filters-wrapper');
    var appliedFiltersListParentDiv = appliedFiltersParentDiv.find('.tps-melee-stone-listing-applied-filters-list-div');
    var currentFilterCard           = appliedFiltersListParentDiv.find(`.tps-melee-stone-applied-filter-card.tps-filter-${filterType}`);        
    var appliedFilterCard           = '';
    appliedFiltersParentDiv.find('.tps-melee-stone-applied-filter-reset-div').remove();
    if (filterOptions.length > 0) {
        if (currentFilterCard.length < 1) {
            appliedFilterCard += `<div class="tps-melee-stone-applied-filter-card tps-filter-${filterType}">`;    
        }
        appliedFilterCard     += `            
            <span class="tps-melee-stone-applied-filter-card-label">${filterLabel}:</span>
            <div class="tps-melee-stone-applied-filter-card-option-list">`;
            if (filterHTMLType == 'checkbox-filter') {
                for (var filterOption of filterOptions) {
                    appliedFilterCard += `
                    <div class="tps-melee-stone-applied-filter-card-option" data-filter-type="${filterType}" data-filter-option="${filterOption}">
                        <span class="tps-melee-stone-applied-filter-card-option-label">${filterOption}</span>
                        <span class="tps-melee-stone-applied-filter-card-option-remove"></span>
                    </div>
                    `;
                }    
            } else if(filterHTMLType == 'range-filter') {
                appliedFilterCard += `
                <div class="tps-melee-stone-applied-filter-card-option" data-filter-type="${filterType}">
                    <span class="tps-melee-stone-applied-filter-card-option-label">${filterOptions.join('-')}</span>
                    <span class="tps-melee-stone-applied-filter-card-option-remove"></span>
                </div>`;
            }
            appliedFilterCard += `
            </div>                
        `;
        if (currentFilterCard.length < 1) {
            appliedFilterCard += `</div>`;    
        }

        if (currentFilterCard.length > 0) {
            currentFilterCard.html(appliedFilterCard);
        } else {
            appliedFiltersListParentDiv.append(appliedFilterCard);
        }
    } else {
        currentFilterCard.remove();
    }
    
    if (appliedFiltersListParentDiv.find('.tps-melee-stone-applied-filter-card').length > 0) {
        var resetAppliedFiltersDiv = `
            <div class="tps-melee-stone-applied-filter-reset-div">
                <span class="tps-melee-stone-applied-filter-title">Applied Filters</span>
                <button class="tps-melee-stone-applied-filter-reset-btn">Clear All</button>
            </div>
        `;
        appliedFiltersParentDiv.prepend(resetAppliedFiltersDiv);
        appliedFiltersParentDiv.show();
    } else {
        appliedFiltersParentDiv.hide();
    }
   }

   /* empty applied filters div */
   function emptyAppliedFiltersDiv() {    
    var appliedFiltersParentDiv = jQuery('.tps-melee-stone-listing-applied-filters-wrapper');
    appliedFiltersParentDiv.find('.tps-melee-stone-applied-filter-reset-div').remove();
    appliedFiltersParentDiv.find('.tps-melee-stone-listing-applied-filters-list-div').empty();
    appliedFiltersParentDiv.hide();
   }

   /* reset melee stone filters */
   function resetMeleeStoneFilters() {        
    sessionStorage.removeItem(filterSessionStorageKey);
    emptyAppliedFiltersDiv();
    resetMeleeStoneCheckboxFilters();
    resetMeleeStoneRangeFilters();
    resetMeleeStoneSortOptions();
    updatePageURL('');
    resetPageToFirstPage();
    emptyMeleeStonesResultDiv();
    fetchMeleeStones();
   }

   /* reset all checkbox filters */
   function resetMeleeStoneCheckboxFilters() {
    jQuery('.tps-checkbox-filter').find('.tps-filter-option-chk').prop('checked', false);
   }

   /* reset range filters */
   function resetMeleeStoneRangeFilters() {
    jQuery('.tps-range-filter').each(function() {
        var curRangeFilterDiv = jQuery(this);
        var defaultMinVal = curRangeFilterDiv.find('.tps-melee-stone-min-default-val').val();
        var defaultMaxVal = curRangeFilterDiv.find('.tps-melee-stone-max-default-val').val();
        curRangeFilterDiv.find('.tps-melee-stone-min-inp-field').val(defaultMinVal);
        curRangeFilterDiv.find('.tps-melee-stone-max-inp-field').val(defaultMaxVal);
    });
   }

   /* fetch melee stones */
   function fetchMeleeStones() {
    var appliedFilters      = getAppliedFilterList();
    var appliedSortConfig   = getMeleeStoneSortOptions();
    var graphqlQuery        = getGraphqlQueryRequest(appliedFilters, appliedSortConfig);
    if (requestXHR) {
        requestXHR.abort();
    }
    requestXHR = jQuery.ajax({
        url : graphqlAPIURL,
        method: 'POST',
        contentType: 'application/json',
        dataType: 'json',
        data : JSON.stringify({ query : `query{${graphqlQuery}}`}),
        beforeSend : function() {            
            jQuery('.tps-melee-stone-count').addClass('tps-loading');
            jQuery('.tps-melee-stone-result-grid-loader').show();
            jQuery('.tps-melee-stone-item-not-found-wrapper').hide();
            jQuery('.tps-melee-stone-load-more-content').hide();
        },
        success : function(response) {
            var graphqlResponse = response['data'][stoneListingAPIName];                        
            if (graphqlResponse.meleeDiamond.length > 0) {
                printMeleeStoneData(graphqlResponse.meleeDiamond);
                handleMeleeStoneCountText(graphqlResponse.dataCount);                
                handleLoadMoreContent(graphqlResponse.dataCount);
            } else {
                handleMeleeStoneCountText(0);
                jQuery('.tps-melee-stone-item-not-found-wrapper').show();                                
                jQuery('.tps-melee-stone-result-grid').empty();                
            }
        },
        complete : function() {            
            jQuery('.tps-melee-stone-result-grid-loader').hide();
            jQuery('.tps-melee-stone-count').removeClass('tps-loading');
        },
        error : function() {            
            jQuery('.tps-melee-stone-item-not-found-wrapper').show();
            jQuery('.tps-melee-stone-result-grid-loader').hide();
            jQuery('.tps-melee-stone-count').removeClass('tps-loading');
            jQuery('.tps-melee-stone-count').text(0);
            jQuery('.tps-melee-stone-result-grid').empty();
            jQuery('.tps-melee-stone-load-more-content').hide();
        }
    }); 
   }

   /* handle melee stone count text */
   function handleMeleeStoneCountText(stoneCount) {
    jQuery('.tps-melee-stone-count').text(stoneCount);    
   }

   /* handle load more content */
   function handleLoadMoreContent(totalMeleeStoneCount) {
    var totalMeleeStoneCards = jQuery('.tps-melee-stone-info-card').length;
    var totalPages           = Math.ceil(totalMeleeStoneCount/pageSize); 
    var loadMoreContentHTML  = `You have viewed ${totalMeleeStoneCards} of ${totalMeleeStoneCount}`;
    if ((totalMeleeStoneCount > pageSize) && (curPage < totalPages)) {
        loadMoreContentHTML+= '<button class="tps-melee-stone-load-more-btn">Load More</button>';
    }
    loadMoreContentHTML += '<span class="tps-melee-stone-go-top-link">Use filters to refine your results</span>';
    jQuery('.tps-melee-stone-load-more-content').html(loadMoreContentHTML).show();
   }

   /* display melee stone data in result grid */
   function printMeleeStoneData(meleeStoneList = []) {
    var meleeStonesHTML = '';
    for(var meleeStoneInfoJSON of meleeStoneList) {
        meleeStonesHTML += getSingleMeleeStoneHTML(meleeStoneInfoJSON);
    }
    jQuery('.tps-melee-stone-result-grid').append(meleeStonesHTML);
    assignDynamicHeightToMediaDiv();
   }

   /* assign dynamic height to media div */
   function assignDynamicHeightToMediaDiv() {
    var meleeStoneItemMediaDiv  = jQuery('.tps-melee-stone-top-content-left.tps-img-container');
    var mediaDivOuterWidth 	    = meleeStoneItemMediaDiv.outerWidth();
	meleeStoneItemMediaDiv.css('height', `${mediaDivOuterWidth}px`);
   }

   /* check current stone is under whats app selection */
   function isStoneSelectedForWhatsApp(curInfoJSON) {
    var isSelected = false;
    for(var stoneInfo of selectedProductSKUList) {
        if (stoneInfo['productSku'] == curInfoJSON['productSku']) {
            isSelected = true;
            break;
        }
    }
    return isSelected;
   }

   /* get single melee stone card html */
   function getSingleMeleeStoneHTML(meleeStoneInfoJSON = {}) {
    var stoneTitle      = getMeleeStoneTitle(meleeStoneInfoJSON);
    var color           = meleeStoneInfoJSON['color'] != '' ? meleeStoneInfoJSON['color'] : meleeStoneInfoJSON['fancyColor'];
    var colorIntensity  = meleeStoneInfoJSON['fancyColorIntensity'] != '' ? meleeStoneInfoJSON['fancyColorIntensity'] : '';
    var cardHTML        = `
    <div class="tps-melee-stone-info-card tps-stone-id-${meleeStoneInfoJSON['productSku']}">
        <div class="tps-melee-stone-top-content">
            <div class="tps-melee-stone-top-content-left tps-img-container">
                <img src="${meleeStoneInfoJSON['image']}" class="tps-melee-stone-main-img" alt="${stoneTitle}" title="${stoneTitle}" width="331" height="330" onerror="this.onerror=null;this.src='${placeholderImgURL}';" />
            </div>
            <div class="tps-melee-stone-top-content-right tps-title-badge-container">
                <span class="tps-melee-stone-title">${stoneTitle}</span>
                <span class="tps-melee-stone-sku">SKU: ${meleeStoneInfoJSON['productSku']}</span>`;
                if (displayCountry == 'yes') {
                cardHTML += `
                <span class="tps-melee-stone-country">${meleeStoneInfoJSON['location'] != null && meleeStoneInfoJSON['location'] != '' ? meleeStoneInfoJSON['location'] : 'Unknown'}</span>`;    
                }
                if (displayQtyBoxPopup == 'no') {
                cardHTML += `
                <span class="tps-melee-stone-price-block">Price: ${curCurrencySymbol}${getFormatedPrice(meleeStoneInfoJSON['pricePerCarat'])}/ct</span>
                    `;        
                }
                cardHTML += `
                <div class="tps-melee-stone-shareable-div" style="display:${preselectedProductSkus != '' ? 'none' : 'flex'};">
                    <input type="checkbox" class="tps-melee-stone-whats-app-shareable-chk" title="Share By WhatsApp" ${isStoneSelectedForWhatsApp(meleeStoneInfoJSON) ? 'checked' : ''} />
                    <label class="tps-melee-stone-shareable-label"><span>Share By</span></label>
                </div>
            </div>
        </div>
        <div class="tps-melee-stone-mid-content">
            <div class="tps-melee-stone-additional-info-row tps-melee-stone-additonal-info ${colorIntensity != '' ? 'tps-fancy-info-available' : ''}">
                <div class="tps-melee-stone-additional-info-content">
                    <span class="small-text">Shape</span> <span class="smallBold">${meleeStoneInfoJSON['shape']}</span>
                </div>
                <div class="tps-melee-stone-additional-info-content">
                    <span class="small-text">Cut</span> <span class="smallBold">${meleeStoneInfoJSON['cut']}</span>
                </div>
                <div class="tps-melee-stone-additional-info-content">
                    <span class="small-text">Color</span> <span class="smallBold">${color} </span>
                </div>
                <div class="tps-melee-stone-additional-info-content">
                    <span class="small-text">Clarity</span> <span class="smallBold">${meleeStoneInfoJSON['clarity']}</span>
                </div>
                <div class="tps-melee-stone-additional-info-content">
                    <span class="small-text">Measurements (mm)</span> <span class="smallBold">${meleeStoneInfoJSON['sizeMmFrom']}-${meleeStoneInfoJSON['sizeMmTo']}</span>
                </div>
                <div class="tps-melee-stone-additional-info-content">
                    <span class="small-text">Avg ct. per stone</span> <span class="smallBold">${meleeStoneInfoJSON['avgCaratPerStone']}</span>
                </div>`;
                if (colorIntensity != '') {
                cardHTML += `
                <div class="tps-melee-stone-additional-info-content">
                    <span class="small-text">Intensity</span> <span class="smallBold">${colorIntensity}</span>
                </div>`;    
                }
                cardHTML += `
            </div>
        </div>`;
        if (displayQtyBoxPopup == 'yes') {
        cardHTML += `
        <div class="tps-melee-stone-bottom-content tps-melee-stone-transaction-btn-group">
            <span class="tps-melee-stone-price-block">Price: ${curCurrencySymbol}${getFormatedPrice(meleeStoneInfoJSON['pricePerCarat'])}/ct</span>
            <button class="tps-melee-stone-select-qty">Select Quantity</button>
        </div>`;
        } else {
            cardHTML += `
            <div class="tps-melee-stone-qty-selector-box-content-wrapper">
                <div class="tps-melee-stone-qty-selector-box-main-content">
                    <!--<span class="tps-melee-stone-qty-selector-box-label">Select by:</span>-->
                    <div class="tps-melee-stone-qty-selector-box-btn-wrapper">
                        <div class="tps-melee-stone-qty-selector-box-btn-group">
                            <button class="tps-melee-stone-qty-selector-box-btn tps-select-by-pieces active">Pieces</button>
                            <button class="tps-melee-stone-qty-selector-box-btn tps-select-by-carat">Carats</button>                            
                        </div>
                        <div class="tps-melee-stone-qty-selector-box-form-wrapper">
                            <div class="tps-melee-stone-qty-selector-box-form tps-form-by-carat" style="display:none;">
                                <div class="tps-melee-stone-qty-selector-box-form-content">
                                    <input type="number" min="0" max="${meleeStoneInfoJSON['caratsAvailable']}" class="tps-melee-stone-qty-selector-box-inp-field" value="${getTotalCaratWeightForSelectedStone(1, meleeStoneInfoJSON['avgCaratPerStone'], false)}" />
                                    <span class="tps-melee-stone-qty-selector-box-form-suffix">ct</span>
                                </div>
                                <span class="tps-melee-stone-qty-selector-box-form-suggestion"></span>
                            </div>
                            <div class="tps-melee-stone-qty-selector-box-form tps-form-by-pieces">
                                <div class="tps-melee-stone-qty-selector-box-form-content">
                                    <input type="number" value="1" min="1" max="${meleeStoneInfoJSON['piecesAvailable']}" class="tps-melee-stone-qty-selector-box-inp-field" />
                                    <span class="tps-melee-stone-qty-selector-box-form-suffix">pcs</span>
                                </div>
                                <span class="tps-melee-stone-qty-selector-box-form-suggestion">${getTotalCaratWeightForSelectedStone(1, meleeStoneInfoJSON['avgCaratPerStone'])}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tps-melee-stone-qty-selector-box-bottom-content">
                    <div class="tps-melee-stone-qty-selector-box-price-block">
                        <span class="tps-melee-stone-qty-selector-box-price-block-label">Cart Price : </span>
                        <span class="tps-melee-stone-qty-selector-box-total-final-price">${getTotalPriceOfSelectedStonePieces(1, meleeStoneInfoJSON['avgCaratPerStone'], meleeStoneInfoJSON['pricePerCarat'])}</span>
                    </div>
                    <div class="tps-melee-stone-qty-selector-box-btn-group">
                        <button class="tps-melee-stone-qty-selector-box-btn tps-add-to-cart">Add to cart</button>
                    </div>
                </div>
                <span class="tps-melee-stone-qty-selector-box-error-note"></span>
            </div>    
            `;
        }
        cardHTML += `
        <input type="hidden" class="tps-melee-stone-info-json" value='${JSON.stringify(meleeStoneInfoJSON)}' />
    </div>
    `;
    return cardHTML;
   }

   /* get formated price */
   function getFormatedPrice(curPrice) {
    return parseFloat(curPrice).toLocaleString('en-US');
   }

   /* get stone type title by slug */
   function getStoneTypeTitle() {
    var stoneTypeTitle  = '';
    var curStoneType    = getStoneTypeBySlug(stoneTypeSlug);    
    switch (curStoneType) {
        case 'natural-white':
        stoneTypeTitle = 'Natural';
        break;
    
        case 'natural-fancy':
        stoneTypeTitle = 'Natural Fancy';
        break;

        case 'lab-white':
        stoneTypeTitle = 'Lab';
        break;

        case 'lab-fancy':
        stoneTypeTitle = 'Lab Fancy';
        break;
    }
    return stoneTypeTitle;
   }

   /* get melee stone title */
   function getMeleeStoneTitle(meleeStoneInfoJSON = {}) {
    var color = meleeStoneInfoJSON['color'] != '' ? meleeStoneInfoJSON['color'] : meleeStoneInfoJSON['fancyColor'];
    return `${color} ${getStoneTypeTitle()} ${meleeStoneInfoJSON['shape']} ${meleeStoneInfoJSON['cut']} ${meleeStoneInfoJSON['sizeMmFrom']}-${meleeStoneInfoJSON['sizeMmTo']} mm`;
   }

   /* get melee stone graphql request body */
   function getGraphqlQueryRequest(appliedFilters, appliedSortConfig) {
    if (preselectedProductSkus != '') appliedFilters = {};
    var appliedShapes        = appliedFilters.hasOwnProperty('stone-shapes') ? appliedFilters['stone-shapes'] : '';
    var appliedColors        = appliedFilters.hasOwnProperty('non-fancy-colors') ? appliedFilters['non-fancy-colors'] : (appliedFilters.hasOwnProperty('fancy-colors') ? appliedFilters['fancy-colors'] : '');
    var appliedCaratRange    = appliedFilters.hasOwnProperty('carat-range') ? appliedFilters['carat-range'] : '';
    var appliedClarity       = appliedFilters.hasOwnProperty('clarities') ? appliedFilters['clarities'] : '';
    var appliedCut           = appliedFilters.hasOwnProperty('cuts') ? appliedFilters['cuts'] : '';
    var appliedMeasurement   = appliedFilters.hasOwnProperty('measurements') ? appliedFilters['measurements'] : '';
    var appliedColorIntensity= appliedFilters.hasOwnProperty('fancy-color-intensities') ? appliedFilters['fancy-color-intensities'] : '';
    var appliedPriceRange    = appliedFilters.hasOwnProperty('price-range') ? appliedFilters['price-range'] : '';
    var stoneType            = getStoneTypeBySlug(stoneTypeSlug);
    var sortByValue          = appliedSortConfig['sort_by'];
    var sortDirValue         = appliedSortConfig['sort_dir'];
    var query = `${stoneListingAPIName}(page: "${curPage}", pageSize:"${pageSize}", shapes:"${appliedShapes}", color:"${appliedColors}", fancyColorIntensity:"${appliedColorIntensity}", avgCarat:"${appliedCaratRange}", clarity:"${appliedClarity}", cut:"${appliedCut}", size:"${appliedMeasurement}", price:"${appliedPriceRange}", productSkus:"${preselectedProductSkus}", diamondType:"${stoneType}", currencyFlag:"${curCurrencyCode}", orderBy:"${sortByValue}", sortBy:"${sortDirValue}", bulkPageData:"no") {
        dataCount
        meleeDiamond{
            productSku
            shape
            cut
            color
            fancyColor
            fancyColorIntensity
            clarity
            sizeMmFrom
            sizeMmTo
            caratsAvailable
            piecesAvailable
            avgCaratPerStone
            pricePerCarat
            image
            diamondType
            growthMethod
            location
            treated
            tolerance
            isVerified
            isReturnable
        }
    }`;
    return query;
   }

   /* get stone type by slug */
   function getStoneTypeBySlug(stoneTypeSlug) {
    var stoneType = 'natural-white';
    switch (stoneTypeSlug) {
        case 'natural-melee-stones':
            stoneType = 'natural-white';    
        break;

        case 'lab-melee-stones':
            stoneType = 'lab-white';    
        break;

        case 'natural-fancy-melee-stones':
            stoneType = 'natural-fancy';    
        break;

        case 'lab-fancy-melee-stones':
            stoneType = 'lab-fancy';    
        break;
    }
    return stoneType;
   }

   /* get applied filter list */
   function getAppliedFilterList() {
    var appliedFilters       = {};
    var storedAppliedFilters = sessionStorage.getItem(filterSessionStorageKey);
    if (storedAppliedFilters != '' && storedAppliedFilters != undefined && storedAppliedFilters != null) {
        appliedFilters       = JSON.parse(storedAppliedFilters);    
    }
    return appliedFilters;
   }

   /* get default min/max values from range filters */
   function getDefaultMinMaxFilterValues(filterDiv) {
        var defaultMinVal = parseFloat(filterDiv.find('.tps-melee-stone-min-default-val').val());
        var defaultMaxVal = parseFloat(filterDiv.find('.tps-melee-stone-max-default-val').val());
        return {defaultMinVal, defaultMaxVal};
   }

   /* get user selected checkbox filter options */
   function getSelectedChkFilterOptions(filterDiv) {
    var selectedOptions = [];
    var checkedOptions  = filterDiv.find('.tps-filter-option-chk:checked');
    if (checkedOptions.length > 0) {
        checkedOptions.each(function() {
            selectedOptions.push(jQuery(this).val());
        });
    }
    return selectedOptions; 
   }

   /* update URL query parameters for stone filters */
   function updateFilterURLQueryParams(filterType, filterOptions = []) {
    if (filterOptions.length > 0) {
        queryParams.set(filterType, filterOptions);
    } else {
        queryParams.delete(filterType);
    }
    updatePageURL(queryParams);
   }

    /* update current page URL with query params */
	function updatePageURL(queryParams = '') {
		var currentURLPath = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
		var newUrl 		   = `${currentURLPath}?${queryParams ? queryParams.toString() : ''}`;
        window.history.pushState({ path: newUrl }, '', newUrl);
	}

   /* update session storage parameters for stone filters */
   function updateFilterSessionStorageParams(filterType, filterOptions = []) {
    var filterJSON = {};
    var storedFilters = sessionStorage.getItem(filterSessionStorageKey);
    if(storedFilters != null && storedFilters != undefined && storedFilters != '') {
        filterJSON = JSON.parse(sessionStorage.getItem(filterSessionStorageKey));
    }
    if (filterOptions.length < 1) {
        delete filterJSON[filterType];
    } else {
        filterJSON[filterType] = filterOptions.join(',');
    }
    if (Object.keys(filterJSON).length > 0) {
        sessionStorage.setItem(filterSessionStorageKey, JSON.stringify(filterJSON));
    } else {
        sessionStorage.removeItem(filterSessionStorageKey);
    }
   }
});